import InfoIcon from "../../../icons/InfoIcon";
import React from "react";
import useResponsive from "../../../hooks/useResponsive";
import ToolTip from "../../../components/ToolTip/ToolTip";
import {useTranslation} from "react-i18next";

const PriceLabel = ({price, shortLabel=false}) => {
    const {t} = useTranslation();
    if (!price.label) {
        return null
    }

    const getLabel = () => {
        if (shortLabel) {
            return `-${price.percentage}%`
        }
        return price.label
    }

    return (
        <div className={'promo_price_label'}
             style={{
                 backgroundColor: price.bg_color,
                 color: price.txt_color
             }}>{getLabel()}
            {!shortLabel && <ToolTip
                tooltipText={price.description.map((desc, index) => (
                    <div key={index}>{desc}</div>
                ))}
            ><InfoIcon className={'info-icon'} fill={price.txt_color}/>
            </ToolTip>}
        </div>
    )
}

export default PriceLabel